import type { CSVAssetPreview } from "../ChatEventTypes.ts";
import { InteractiveTableView } from "./InteractiveTableView.tsx";

type AssetPreviewCSVProps = {
	asset: CSVAssetPreview;
};

export const AssetPreviewCSV = (props: AssetPreviewCSVProps) => {
	const previewRows = () => props.asset.rows_preview;
	const totalRows = () => props.asset.total_rows ?? previewRows().length;
	const truncationMessage = () =>
		totalRows() > previewRows().length
			? `Showing ${previewRows().length} of ${totalRows()} rows`
			: undefined;

	return (
		<InteractiveTableView
			headers={props.asset.headers}
			rows={previewRows()}
			truncationMessage={truncationMessage()}
		/>
	);
};
